import { render, staticRenderFns } from "./mianban.vue?vue&type=template&id=11e96bc6&scoped=true&"
import script from "./mianban.vue?vue&type=script&lang=js&"
export * from "./mianban.vue?vue&type=script&lang=js&"
import style0 from "./mianban.vue?vue&type=style&index=0&id=11e96bc6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e96bc6",
  null
  
)

export default component.exports